import publish from '@/services/publish'

export default {
  '/device/mode_switch': publish.changeMode,
  '/user/parental_mode/add': publish.changeParentalMode,
  '/user/parental_mode/delete': publish.changeParentalMode,
  '/user/add': publish.addChild,
  '/device/add': publish.addChildDevice,
  '/device/last_seen': publish.updateDeviceLastSeen,
  '/user/device_event_add': publish.addDeviceEvent,
  '/group/new_feed_item': publish.addFeedItem,
  '/user/delete': publish.deleteChild,
  'license_change': publish.changeLicense,
  '/device/delete': publish.removeChildDevice,
  '/request_access/add': publish.addRequestAccess,
  '/request_access/deny': publish.removeRequestAccess,
  '/request_access/grant': publish.removeRequestAccess,
  '/schedule/update': publish.updateSchedule,
  '/user/settings/update': publish.updateChildSettings,
  '/category_setting/set': publish.updateCategorySetting,
  '/category_setting/delete': publish.removeCategorySetting,
  '/app_setting/set': publish.updateAppSetting,
  '/url_setting/add': publish.addUrlSetting,
  '/url_setting/delete': publish.removeUrlSetting,
  '/custom_category/add': publish.addCustomCategory,
  '/custom_category/update': publish.updateCustomCategory,
  '/custom_category/delete': publish.removeCustomCategory,
  '/user/location_add': publish.addLocation,
  '/named_location/add': publish.addNamedLocation,
  '/named_location/update': publish.updateNamedLocation,
  '/named_location/delete': publish.removeNamedLocation,
  '/named_location/alert_setting': publish.updateNamedLocationSettings,
  '/user/update': publish.updateChild,
  '/user/screen_time_update': publish.updateScreenTime,
  '/user/youtube_data_add': publish.addYoutubeView,
  '/user/social_media_settings/set': publish.updateSocialMediaSetting,
  '/user/social_media_settings/block_all': publish.updateAllSocialMedia,
  '/user/social_media_settings/allow_all': publish.updateAllSocialMedia,
  '/user/social_media_settings/block_unsupported': publish.updateUnsupportedSocialMedia,
  '/user/social_media_settings/allow_unsupported': publish.updateUnsupportedSocialMedia
}